export default {

  setConfigItems(state, data) {
    state.configItems = data;
  },

  setPageContent(state, data) {
    state.pageContent = data;
  },

  setBankCards(state, data) {
    state.bankCards = data;
  },

  setBanners(state, data) {
    state.banners = data;
  },

  setBankCard(state, data) {
    state.bankCard = data;
  },

  setTickets(state, data) {
    state.tickets = data;
  },

  setTicket(state, data) {
    state.ticket = data;
  },

  setDashboardItems(state, data) {
    state.dashboardItems = data;
  },

  setSearchVendors(state, data) {
    state.searchVendors = data;
  },

  setRequirementProfile(state, data) {
    state.requirementProfile = data;
  },



};
